import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AuthService } from 'src/app/Service/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-signup-type',
    templateUrl: './signup-type.component.html',
    styleUrls: ['./signup-type.component.css'],
    standalone: false
})
export class SignupTypeComponent implements OnInit {

  showContent: boolean = false;
  dynamicClass: string = '';
  sourceFrom: boolean = false;

  @ViewChild('pricing') pricing!: TemplateRef<any>;

  constructor(
    public auth: AuthService,
    public modalService: NgbModal,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.showContent = params['app'] === 'true';

      this.dynamicClass = this.showContent ? 'ShowOne' : 'ShowTwo';
      this.sourceFrom = this.showContent;
    });
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  onClose() {
    this.modalService.dismissAll();
  }

  ContinueProfiessional() {   
    this.auth.login('authprofessional', this.sourceFrom);
  }
}